import { useFeatureFlagContext } from './featureFlags';
import { useNewGuestLandingDocumentTheme } from './useNewGuestLandingDocumentTheme';

export const DocumentTheme = () => {
  const { isEnabled } = useFeatureFlagContext();
  useNewGuestLandingDocumentTheme(isEnabled('newGuestLandingPage'));

  return null;
};
